module.exports = __webpack_public_path__ + "static/media/infoIcon.0f17b68a.svg";